import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TerminosCondicionesEntry } from 'src/app/shared/entrys/terminos-condiciones.entry';

@Component({
	selector: 'app-modal-termino-condiciones',
	templateUrl: './modal-termino-condiciones.component.html',
	styleUrls: ['./modal-termino-condiciones.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalTerminoCondicionesComponent implements OnInit {
	@Input()
	terminos: TerminosCondicionesEntry;

	constructor(private activeModal: NgbActiveModal) { }

	ngOnInit() {
	}

	confirm(): void {
		if (this.activeModal) {
			this.activeModal.close();
		}
	}

	dismiss(): void {
		if (this.activeModal) {
			this.activeModal.dismiss();
		}

	}

}
